import Cookies from 'universal-cookie';
import Layout from './layout';
import Portfolio from '../screens/portfolio/index';
import HistoryPrereq from '../screens/history/prereq';
import TradePrereq from '../screens/trade/prereq';
import InstantPrereq from '../screens/instant/prereq';
// import StandardPrereq from '../screens/standard/prereq';
import Wallets from '../screens/wallets/index';
import Settings from '../screens/settings/index';
import ChangePassword from '../screens/settings/changepassword';
import GlobalLock from '../screens/settings/globallock';
import SignInWithEthereum from '../screens/settings/siwe';
import LoginHistory from '../screens/settings/loginhistory';
import Sessions from '../screens/settings/sessions';
import DeviceWhitelist from '../screens/settings/devicewhitelist';
import Referral from '../screens/referral';
import Kyc from '../screens/kyc';
import ConfirmWithdrawal from '../screens/wallets/confirmwithdrawal';
import LoggedIn from './loggedin';
import Oauth from '../screens/oauth';
import IdentityLogIn from '../screens/identity/login';
import IdentityRegister from '../screens/identity/register';
import IdentityAccRecover from '../screens/identity/recover';
import IdentityReverify from '../screens/identity/reverify';
import IdentityPassRecover from '../screens/identity/passrecover';
import IdentityEmailValidate from '../screens/identity/emailvalidate';
import IdentityEmailReset from '../screens/identity/emailReset';
import IdentityOtpRecover from '../screens/identity/otprecover';
import IdentityOtpValidate from '../screens/identity/otpvalidate';
import AddressBook from '../screens/addressbook';
import AutomationPrereq from '../screens/automation/prereq';
import EurTradePrereq from '../screens/eurtrade/prereq';

const cookies = new Cookies();

const idRedirectCookie = cookies.get('_vtir');

let identityEnabled;

if (process.env.REACT_APP_IDENTITY_REDIRECT === 'true') {
  identityEnabled = true;
}
if (idRedirectCookie) {
  identityEnabled = true;
}

const Routes = [
  {
    component: Layout,
    routes: [
      {
        path: '/validate',
        exact: true,
        component: Oauth,
      },
      {
        path: '/login',
        exact: true,
        component: IdentityLogIn,
      },
      {
        path: '/register',
        exact: true,
        component: IdentityRegister,
      },
      {
        path: '/recover',
        exact: true,
        component: IdentityAccRecover,
      },
      {
        path: '/reverify',
        exact: true,
        component: IdentityReverify,
      },
      {
        path: '/forgot-password',
        exact: true,
        component: IdentityPassRecover,
      },
      {
        path: '/verify-email',
        exact: true,
        component: IdentityEmailValidate,
      },
      {
        path: '/reset-two-factor',
        exact: true,
        component: IdentityOtpRecover,
      },
      {
        path: '/verify-two-factor',
        exact: true,
        component: IdentityOtpValidate,
      },
      {
        path: '/change-email',
        exact: true,
        component: IdentityEmailReset,
      },
      {
        path: '/',
        exact: true,
        component: LoggedIn(Portfolio),
      },
      {
        path: '/audit',
        component: () => {
          window.location.href = 'https://vaultoro.com/audit'; return null;
        },
      },
      {
        path: '/history',
        exact: true,
        component: LoggedIn(HistoryPrereq),
      },
      // {
      //   path: '/trade',
      //   exact: true,
      //   component: LoggedIn(TradePrereq),
      // },
      {
        path: '/direct',
        exact: true,
        component: LoggedIn(InstantPrereq),
      },
      {
        path: '/wallets',
        exact: true,
        component: LoggedIn(Wallets),
      },
      {
        path: '/settings',
        exact: true,
        component: LoggedIn(Settings),
      },
      {
        path: '/settings/change-password',
        exact: true,
        component: LoggedIn(ChangePassword),
      },
      {
        path: '/settings/global-lock',
        exact: true,
        component: LoggedIn(GlobalLock),
      },
      {
        path: '/settings/sign-in-with-ethereum',
        exact: true,
        component: LoggedIn(SignInWithEthereum),
      },
      {
        path: '/settings/login-history',
        exact: true,
        component: LoggedIn(LoginHistory),
      },
      {
        path: '/settings/login-sessions',
        exact: true,
        component: LoggedIn(Sessions),
      },
      {
        path: '/settings/device-whitelisting',
        exact: true,
        component: LoggedIn(DeviceWhitelist),
      },
      {
        path: '/referral',
        exact: true,
        component: LoggedIn(Referral),
      },
      {
        path: '/kyc',
        exact: true,
        component: LoggedIn(Kyc),
      },
      {
        path: '/wallets/confirm-withdrawal',
        exact: true,
        component: LoggedIn(ConfirmWithdrawal),
      },
      {
        path: '/addressbook',
        exact: true,
        component: LoggedIn(AddressBook),
      },
      {
        path: '/automation',
        exact: true,
        component: LoggedIn(AutomationPrereq),
      },
      {
        path: '/fiat-trade',
        exact: true,
        component: LoggedIn(EurTradePrereq),
      },
      {
        path: '*',
        component: () => {
          window.location.href = '/'; return null;
        },
      },
    ],
  },
];

export default Routes;
